import globals from "@homer.core/globals";

const enabled = {};

globalThis.addEventListener("hashchange", (event) => {
    if (!location.hash.startsWith("#debug:")) {
        for (let item in enabled) {
            const node = enabled[item]?.node;

            if (node) {
                node.detach();
            }

            delete enabled[item];
        }

        return;
    }

    location.hash
        .substring(7)
        .split(",")
        .filter((item) => {
            item = enabled[item];

            return !item || !item.node.isConnected;
        })
        .forEach((item) => {
            globals.demand.request(`@debug/${item}`).then(([Item]) => {
                enabled[item] = new Item();
            });
        });
});
